export const politics = [
    {
        id: "content-politics-what-really-matters",
        name: "本当に重要なこと",
        articles: [
            {
                id: "5fed924d-8356-4d2e-bf06-ba58866f4cd0",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "0e4a3d8c-a290-4921-9067-0c6f06f318f6",
                        image: {
                            src: "assets/images/emmanuel-ikwuegbu-ceawFbpA-14-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "無料の請求書でのニンジン。バスケットボールの妊娠臨床を非常にストレスに包む人は誰でも執行します。現在のTristiqueのふもとにある。もちろん、唐辛子の物語のこの過程で裁判所。",
                        url: "#",
                    },
                    {
                        id: "b5487ca6-95b7-4dc9-a96b-127ba70c1601",
                        image: {
                            src: "assets/images/mr-cup-fabien-barral-Mwuod2cm8g4-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "によって滅菌されたオニメ。時々、はメンバーではありません。モーリスウィークエンド写真モーリスは宿題のみです。",
                        url: "#",
                    },
                    {
                        id: "6eb4edcf-6a84-4997-b053-f63bf6757f24",
                        image: {
                            src: "assets/images/colin-lloyd-uaM_Ijy_joY-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "しかし、プロパガンダ車は全国の生活から抜け出します。ポットまたは開発者を常に紹介します。今すぐチャットしますが、サッカーサラダなどのサッカーメンバーにお願いします。それぞれまたは臨床および著者の妊娠中の化粧。",
                        url: "#",
                    },
                    {
                        id: "a0fd29d4-8eaa-470b-9f6e-5ee20680cba9",
                        image: {
                            src: "assets/images/sara-cottle-bGjtWs8sXT0-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "トマトチリを喉に調査してください。アース・モーリスは直径のメーセナスですが。またはではありません。嫌いなフットボールフェージャットプライスニブ。",
                        url: "#",
                    },
                    {
                        id: "c46c8374-58d9-4e4d-b67c-2722031478d8",
                        image: {
                            src: "assets/images/elimende-inagella-7OxV_qDiGRI-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "誰でも、このコースで醜い走りに座っています。今または笑顔でメーセナスを引いてください。今、写真は時々ニンジンを変えました。スマートチリの生態学的なポット革新的な範囲。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-today",
        name: "今日",
        articles: [
            {
                id: "88787560-ed1b-43d5-a57c-bac38c8af902",
                class: "columns-3-wide",
                header: "キャンペーンニュース",
                url: "#",
                image: {
                    src: "assets/images/alexander-grey-8lnbXtxFGZw-unsplash_684.jpg",
                    alt: "プレースホルダー",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
                title: "重要なのは、地域では整数EUチョコレートバリエッドサッカーです。",
                type: "list",
                content: [
                    {
                        id: "b1c84fd6-18ac-4043-83c6-d17da3be2838",
                        content: "マクロ写真IDゲートニブは明日滅菌した。コースの大衆開発者は。",
                    },
                    {
                        id: "f817229a-1567-4892-955f-076d736c2e40",
                        content: "各矢印唐辛子が重要です。サッカーはあなたのたくさんです。",
                    },
                    {
                        id: "44719b28-a2bb-49d1-8391-cd79e8cd74cf",
                        content: "投資臨床ヌラ栄養サッカーが重要です。",
                    },
                    {
                        id: "9d4e196a-50a8-45b1-9d13-0594b4728ce9",
                        content: "ウォームアップとケアと臨床栄養素執行地域で.",
                    },
                ],
            },
            {
                id: "8eeaee25-a813-430f-9f1e-00ac72d6e0f9",
                class: "columns-3-narrow",
                header: "選挙",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "ca84a215-8a32-4591-bb30-18935c91d919",
                        image: {
                            src: "assets/images/red-dot-Q98X_JVRGS0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "今、バナナは妊娠抗酸化物質のために飲みます。酵母のFeugiatは鍋に置かれませんでした。要素フットボールの抗酸化物質での痴漢ですが、病気が嫌いです。チョコレートチリは常にパッケージで宿題が必要です。",
                    },
                    {
                        id: "6016d07f-159b-4bc2-91a1-0009502693e8",
                        image: {
                            src: "assets/images/parker-johnson-v0OWc_skg0g-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "スマートサッカーや笑顔の弧が必要です。妊娠中の弓と温度資産をチャットしないでください。",
                    },
                ],
            },
            {
                id: "f56f95e8-6db3-4fb3-9797-be9e6e8713d1",
                class: "columns-3-narrow",
                header: "地方自治体",
                url: "#",
                image: {
                    src: "assets/images/valery-tenevoy-c0VbjkPEfmM-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "今または笑顔の便利さをプル・メーセナス・レイヤー・ラカス。",
                type: "list",
                content: [
                    {
                        id: "fad4a569-d337-4885-af2e-3da36e7444b3",
                        content: "要素フットボールの抗酸化物質での痴漢ですが、病気が嫌いです。",
                    },
                    {
                        id: "64208fee-49d3-4536-863c-7a03741acd62",
                        content: "多くのプレイヤーが顧客を受け取り、補償を飲みます。",
                    },
                    {
                        id: "f28139dc-e8b6-4d3b-86ad-8ef8ed5f6828",
                        content: "アルコールの各執行の直径を飲むか、望んでいます。",
                    },
                    {
                        id: "9e7e7929-ac40-4a14-bf41-467af7bc2bbc",
                        content: "は、顧客のチームを必要としています。週末と人生の開発者のために.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-latest-headlines",
        name: "最新のヘッドライン",
        articles: [
            {
                id: "a497dc76-3124-4e34-a562-393b3ed0a2d0",
                class: "columns-3-balanced",
                header: "分析",
                image: {
                    src: "assets/images/scott-graham-OQMZwNd3ThU-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ペレンテスクのバレーボール栄養居住者サッカー悲しい古いオールドとネトゥスと。",
                type: "list",
                content: [
                    {
                        id: "9709aba3-dea5-4634-af0d-a0272373fc91",
                        content: "今の子どもたちのキャリア要素は今、願います。",
                    },
                    {
                        id: "56b038d5-ae4d-4eb0-a24f-eadd6e933311",
                        content: "しかし、サッカーのプール、しかし湖であるが漫画が入っている場合。",
                    },
                    {
                        id: "74f5f5fa-d5cf-4854-a52b-7d267ba01da6",
                        content: "純粋なニンジンは、滅菌された滅菌を勾配して大きな生態学的でした。簡単な週末は屋外のエグシャンです。",
                    },
                    {
                        id: "585db761-3e2b-4789-9e7f-3e8a3ab70aae",
                        content: "笑い、層のプールや抗酸化物質の週末を引っ張ってください。",
                    },
                ],
            },
            {
                id: "3b2ff2f5-1aa4-471d-afe4-4134e7239b3a",
                class: "columns-3-balanced",
                header: "最初に事実",
                image: {
                    src: "assets/images/campaign-creators-pypeCEaJeZY-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "さまざまなまたは震えまたはターピスでは、ロアムの痛みが必要になりました。",
                type: "list",
                content: [
                    {
                        id: "b6d3d1d2-9ef8-48a2-8463-07eb4cd0757c",
                        content: "ミネアポリスチリUTスロートバレーボール要素が綴られています。",
                    },
                    {
                        id: "53572fab-f3f1-4c47-ab93-b2896352265a",
                        content: "チリは常に宿題が必要です。開発者のサッカーの大衆には、チリの漫画層が執行されています。",
                    },
                    {
                        id: "528626d6-5909-42a3-a4a1-b406ac06c673",
                        content: "寿命マクロソースラシニアの必須ミサ1つ以上。",
                    },
                    {
                        id: "6d3ce580-c7a6-4bf7-b93a-e012e21f6037",
                        content: "晴れた古いものとネタスとマレスアダ。",
                    },
                ],
            },
            {
                id: "d3f0d391-b7ad-4421-a6d2-7d004a21d6d9",
                class: "columns-3-balanced",
                header: "より多くの政治ニュース",
                image: {
                    src: "assets/images/priscilla-du-preez-GgtxccOjIXE-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "サッカープロパガンダの著者の人生は、さまざまなものでアルコール飲み物をベッドします。",
                type: "text",
                content:
                    "震えの直径ニンジンプレイヤーは飲み物の箱を受け取ります。その調査では、マイクロ波のニブが選択されました。革新的なライオンの最新のゲートウェイロレムソフト。あなたが子供を嫌うまで、パスポートフットボールの写真とトリガー.\n\n人生のゲームのゲーム、人生のゲームの要素の矢。地域のモーリスに直径を伝える可能性がありますが、の場合。ライフサスシピットテルスがない限り、モーリスは現在計画しています。ゲートウェイが柔らかくない場合。",
            },
        ],
    },
    {
        id: "content-politics-latest-media",
        name: "最新のメディア",
        articles: [
            {
                id: "db2737cd-27a6-479d-a387-ad8009ede603",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "8879d7ec-ecde-4a40-b463-eaf0beb033db",
                        image: {
                            src: "assets/images/ruben-valenzuela-JEp9cl5jfZA-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "ff8f1fca-f830-4450-a946-075f95f37569",
                        image: {
                            src: "assets/images/gregory-hayes-h5cd51KXmRQ-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "ea8500ef-7130-40ef-bb35-a9e5fc6506b6",
                        image: {
                            src: "assets/images/alan-rodriguez-qrD-g7oc9is-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "6481e63a-f2ab-42d3-9c99-cc22cebb3207",
                        image: {
                            src: "assets/images/redd-f-N9CYH-H_gBE-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-election",
        name: "選挙",
        articles: [
            {
                id: "29de4b05-b033-4382-9b05-cd4ad886f497",
                class: "columns-wrap",
                header: "民主党",
                type: "excerpt",
                content: [
                    {
                        id: "c691231f-64bb-4710-bfbf-f4e60fc71457",
                        image: {
                            src: "assets/images/dyana-wing-so-Og16Foo-pd8-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "必須のマティスvulputateはゼロです。週末には、恐怖のフットボールの滅菌地域としての直径。明日バレーボールロットは今座っています。恐怖が都合の良い時にあった前。現在の元素抗酸化物質ではありません。",
                    },
                    {
                        id: "0c01ee2b-971a-427d-aa7c-02090f28b5d2",
                        image: {
                            src: "assets/images/colin-lloyd-NKS5gg7rWGw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ライフサスシピット地域は直径が最大ですが、エネアスですが、学部の直径まで。は、無料のIDスロートプレーヤーの開発者を強化することがありました。",
                    },
                    {
                        id: "3917e92e-a5db-4c9f-8c2a-42c0bc8f39fe",
                        image: {
                            src: "assets/images/jon-tyson-0BLE1xp5HBQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし、サッカー開発者のサッカーの大衆にはegestasが必要です。バスケットボールまでの屋外。マクロセットをレイヤーし、結果としてこれまでに。このタビターゼ通りの栄養範囲.",
                    },
                ],
            },
            {
                id: "54a12e98-d00c-455d-b806-98594181ce1e",
                class: "columns-wrap",
                header: "共和党員",
                type: "excerpt",
                content: [
                    {
                        id: "7ef5a8ae-55ba-4c4e-b80d-ed02cc2a51db",
                        image: {
                            src: "assets/images/clay-banks-BY-R0UNRE7w-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ストリートは、各矢印唐辛子ニンジンの週末に描かれています。ニブ・モーリス・マティスのテレビの前にターゲットを絞った。",
                    },
                    {
                        id: "57870f0d-6a22-4648-b1fa-66bed5b14f51",
                        image: {
                            src: "assets/images/kelly-sikkema-A-lovieAmjA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "誰でも大きな機能的な痛みです。ペレンテスクのバレーボール栄養居住者サッカー悲しい。の重要な便利な開発者はそれだけの価値があります。",
                    },
                    {
                        id: "7c362a1f-12d0-4aa4-9bf9-490ea6d0ff10",
                        image: {
                            src: "assets/images/chad-stembridge-sEHrIPpkKQY-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "残念ながら、価格または矢印。明日、サッカーの醜い法執行機関の価格ジャスミンのために脂肪を減らします。",
                    },
                ],
            },
            {
                id: "8ad5e658-cfe7-42d1-8e28-764010c5b34f",
                class: "columns-wrap",
                header: "リベラル派",
                type: "excerpt",
                content: [
                    {
                        id: "3c3f4a8c-3b1c-4095-8030-cf45219e5032",
                        image: {
                            src: "assets/images/derick-mckinney-muhK4oeYJiU-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ニンジンが言ったコースは、それまで多くのことです。今すぐプレイヤーをアクティブにする時間です。必須のランニングニンジンは、ちょうどそれまでにニンジンでした。",
                    },
                    {
                        id: "2b882425-c070-46ec-87b8-4fbd5afdf105",
                        image: {
                            src: "assets/images/marek-studzinski-9U9I-eVx9nI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "抗酸化物質がたくさんある場合。私は子供の直径の週末の利便性が嫌いです。特定のサラダでチョコレート漫画モーリスをリクエストしてください。常にがバレーボール電子レンジ妊娠局。",
                    },
                    {
                        id: "5ff98d91-9d27-4638-b093-35118ec4c4f0",
                        image: {
                            src: "assets/images/2h-media-lPcQhLP-b4I-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "醜い法執行機関の価格ジャスミン。開発者の著者ですが、、私の愛する人は重要です。ニブ・モーリス・レーシング・マティスの従業員。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-more-political-news",
        name: "より政治的なニュース",
        articles: [
            {
                id: "ba31d7b5-0a2b-421d-880b-83cbf0503a45",
                class: "columns-3-wide",
                header: "その他のニュース",
                url: "#",
                type: "list",
                content: [
                    {
                        id: "db6b9420-b409-4cc8-8301-aebdd4a61546",
                        content: "ピーナッツティルと憎しみの時間。トリモ価格の漫画スマートフォン。",
                    },
                    {
                        id: "8b43439d-58be-46b1-9e80-4ed4509ecb55",
                        content: "喉のタンクストレスは、時々車両を設置します。しかし、無料ですが、喉は醜いです。",
                    },
                    {
                        id: "f20bc1e5-8744-4750-ac7f-8f8ad64a8726",
                        content: "テレビは標的にされています。アースメイクアップ土壌栄養サッカー開発者温度。",
                    },
                    {
                        id: "82ed67d9-e0d8-471b-8f7d-2d23d7122593",
                        content: "ミネアポリス・ロレムは大規模なサピエンまで。しかし、明日のサッカーアークライブアルコールフットボール。",
                    },
                    {
                        id: "7b58754b-9115-4005-a4b5-3d0841f6918a",
                        content: "サッカーの醜い執行価格ジャスミンQuiverのために取り付けられています。",
                    },
                    {
                        id: "75ad2be4-2ae6-40b7-b99f-7760277897a3",
                        content: "ミネアポリスはベッドにいました。ヴィヴェラ・ニーブ明日マティス今。",
                    },
                    {
                        id: "d18452c7-823c-499e-b67e-490398fa1f54",
                        content: "開発者のサッカーの大衆は、選手の執行唐辛子のレイヤーを必要とします。",
                    },
                    {
                        id: "7e56b434-d474-4cc3-ac87-becc642e351c",
                        content: "しかし、ロレムの門が柔らかくない限り。",
                    },
                    {
                        id: "b0c333a5-7eb4-4142-9141-28cf317adaba",
                        content: "ストレスですが、パッチだけですが、これには領域を引きます。",
                    },
                    {
                        id: "1895e527-3dda-4280-8158-62f2214d30ec",
                        content: "当時のアンティでEUを調査します。サッカーのプロパガンダからアルコール飲料を産む。",
                    },
                    {
                        id: "0198d35a-5253-4a93-9af8-22d2169b88d7",
                        content: "トマトチリを喉に調査してください。",
                    },
                    {
                        id: "e4143447-b828-4b32-8d96-df8fd84763c0",
                        content: "無料の週末ですが、明日のコンピューター。ミネアポリスの学部開発者宿題タンク.",
                    },
                    {
                        id: "89e179d9-7127-4937-a022-f20b81357679",
                        content: "ソースは、生命のソースで滅菌されました。空腹と醜い執行。",
                    },
                    {
                        id: "aff19a6f-a89e-4e4f-bd2c-5291dd95dc9b",
                        content: "プールの賭けですが、アークは嫌いではありません。時間が欲しいのですが、笑顔の価格。",
                    },
                    {
                        id: "a9ce2ec0-2235-46ab-ade2-7fd808ca3de9",
                        content: "明日、栄養開発者のullamcorperサッカーです。私の電子レンジですが、無料です.",
                    },
                ],
            },
            {
                id: "1900eb3e-e44a-481b-abe7-d82aafb5a4ed",
                class: "columns-3-narrow",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "cf0c05c6-a132-40af-b462-1928ed5299b1",
                        image: {
                            src: "assets/images/vanilla-bear-films-JEwNQerg3Hs-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "今、バナナは妊娠抗酸化物質のために飲みます。酵母のFeugiatは鍋に置かれませんでした。要素フットボールの抗酸化物質での痴漢ですが、病気が嫌いです。チョコレートチリは常にパッケージで宿題が必要です。",
                    },
                    {
                        id: "e1d1d173-a259-4091-baea-60c3366fd879",
                        image: {
                            src: "assets/images/dani-navarro-6CnGzrLwM28-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "スマートサッカーや笑顔の弧が必要です。妊娠中の弓と温度資産をチャットしないでください。",
                    },
                    {
                        id: "fbfdf20e-f6e3-404b-b7be-8d9c64d5f0cc",
                        image: {
                            src: "assets/images/wan-san-yip-ID1yWa1Wpx0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "スマートサッカーや笑顔の弧が必要です。妊娠中の弓と温度資産をチャットしないでください。",
                    },
                ],
            },
            {
                id: "212ae8c8-9689-4c4c-b75c-6af97924c561",
                class: "columns-3-narrow",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "5e31f22f-30d5-4d88-97ce-9584a378911e",
                        image: {
                            src: "assets/images/david-beale--lQR8yeDzek-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "チョコレートチョコレートフットボールの地球は、マイクロ波発酵に資金を提供しています。",
                    },
                    {
                        id: "55c34060-7e3d-40a8-9a31-20a15bbed649",
                        image: {
                            src: "assets/images/arnaud-jaegers-IBWJsMObnnU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "重要なのは、フットボールチョコレートのウォームアップにおける悲しい笑顔または。",
                    },
                    {
                        id: "8b96fd4c-1648-4a3c-96a5-c0ac52d02b60",
                        image: {
                            src: "assets/images/kevin-rajaram-qhixFFO8EWQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "やさしく、たくさんのマクロライフ。重要なことに、学部生の悲しい笑顔または発酵のフェージアトまでの直径。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-underscored",
        name: "強調されています",
        articles: [
            {
                id: "78fb02c4-4a19-4c24-a504-fb029810730e",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "c3bd82d1-a2d7-4f10-ac62-e3c6f8812b55",
                        image: {
                            src: "assets/images/kyle-glenn-gcw_WWu_uBQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "大規模な生態学的に卒業した滅菌滅菌を嘆くいくつかの唐辛子ニンジンを服用するために。バスケットボールのどちらもurまたは引っ張る。バニーですが、スマイルの価格は、スマイツサッカーマッサージよりも。地域の整数fチョコレートの笑い声を上げる。自体のチュートリアルNの価格または。",
                        url: "#",
                    },
                    {
                        id: "1405735c-c7e6-4531-ad8c-d4c158960c2e",
                        image: {
                            src: "assets/images/toa-heftiba-4xe-yVFJCvw-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "今、これは一部のティーンエイジャーの恐怖のコースです。バニーの多くの不動産。ライフマクロソースラシニアまたはエロスティルアック。の従業員で。レクスマイクロ波Nibhニスルソース滅菌。週末のメーセナスの週末に座るにはどうやって座っていますか。",
                        url: "#",
                    },
                ],
            },
            {
                id: "c215acac-4b82-4696-a5d7-a33f322c45f3",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "d7f4ffb0-9dfe-45c5-85cf-bed1b25741bd",
                        image: {
                            src: "assets/images/harri-kuokkanen-SEtUeWL8bIQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "しかし、アーチはパフォーマンススカートが嫌われていません。ニンジンが強化されました。チョコレートバスケットボールの生活なら。素敵な写真とサッカーまで。漫画の臨床矢印フットボールの週末は、抗酸化物質が最大のニンジンを憎む。チリは常に骨nの地球で宿題が必要です。",
                        url: "#",
                    },
                    {
                        id: "4ba86b88-39b7-44fd-bf9f-fc2bfc225281",
                        image: {
                            src: "assets/images/ednilson-cardoso-dos-santos-haiooWA_weo-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "要素サッカーの抗酸化物質は病気が嫌いです。サラダの生態学的順序でチョコレート漫画モーリス。シナリオの場合、バナナを引きます。質量ですが、法執行機関の要素期間。実際、谷の鍋のベッドで。サラダ整数の生活は素晴​​らしい必要があります。今は柔らかいですが、私はそうします。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-trending",
        name: "トレンド",
        articles: [
            {
                id: "40fc21b9-2db4-47e2-96ef-2d95e79a9df3",
                class: "columns-wrap",
                header: "新しい法律",
                type: "excerpt",
                content: [
                    {
                        id: "75d1b551-a1cc-4548-aa28-f1d493c5925f",
                        image: {
                            src: "assets/images/markus-spiske-7PMGUqYQpYc-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "あなたまで写真とサッカー。無料の写真は時々カジノがたくさんの紫色を巻き出しています。ランニングパフォーマンスすべてのプルモーレーバレーボールロット今。パッチがこれに領域を引く場合。Polesuadaドリンクアルコールライフエレメントチャット。",
                    },
                    {
                        id: "2d4876f9-45be-4aa9-8ac7-56232b55d649",
                        image: {
                            src: "assets/images/viktor-talashuk-05HLFQu8bFw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "またはウォームアップとケアと臨床で妊娠しています。ジャスミンの価格は大規模で、製造業のレクトゥス・モーリスのバスケットボールを投資します。ライオンまたは臨床ゲートまたはパルビナーまたはの発酵.",
                    },
                    {
                        id: "a1e61b50-4106-4f68-9f35-822452c473bd",
                        image: {
                            src: "assets/images/anastassia-anufrieva-ecHGTPfjNfA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "アークランニングの直径が必要です。いくつかのバスケットボールの矢に注意しない無効なティーンエイジャー。さまざまなまたは震えでアルコール飲料を就寝するプロパガンダ。",
                    },
                ],
            },
            {
                id: "9f10b36d-0666-479c-a234-a7ab95f9737d",
                class: "columns-wrap",
                header: "最新の世論調査",
                type: "excerpt",
                content: [
                    {
                        id: "174f4a54-5f05-499b-8255-9dce7caccff3",
                        image: {
                            src: "assets/images/bianca-ackermann-qr0-lKAOZSk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ゼロの無効なティーンエイジャーがケアを設定する。臨床のテンプレートまたはEU NISL価格。サッカーのサッカーは、直径の栄養価の高い顧客ではありません。チョコレートのティーンエイジャーは価格のvulputate sapienではありません。",
                    },
                    {
                        id: "b5b69901-c646-4034-9f11-d54357ea745b",
                        image: {
                            src: "assets/images/phil-hearing-bu27Y0xg7dk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "要素フットボールのサッカーライオンポットの従業員。ナム製造ロレムセッドスマイル。抗酸化物質または妊娠のために飲むバナナ。最新のサラダとマイク写真IDゲート。時々、変数は、調査なしで多くの滑ブルがたくさんあります。バナナフェリープールの嘆き層温度がないため.",
                    },
                    {
                        id: "9cd2a3f7-3723-4295-af72-fbbfa4a232d2",
                        image: {
                            src: "assets/images/mika-baumeister-Hm4zYX-BDxk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "テレビは今では塊ではありません。学部生の悲しい笑顔またはEUまでの重要な直径。私はジャスミンが嫌いなサッカーが嫌いですが、学部の直径まで。フェリスには、希望のバナナの矢が必要です。私は座りた週末のメーセナスを持っているのが嫌いです。",
                    },
                ],
            },
            {
                id: "d86ca00e-4e84-48ac-8c95-118d7c9a2e44",
                class: "columns-wrap",
                header: "誰が票を獲得しているのか",
                type: "excerpt",
                content: [
                    {
                        id: "6c3745c6-3dc4-435f-b81a-8d2b06cc1ad2",
                        image: {
                            src: "assets/images/wesley-tingey-7BkCRNwh_V0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "地域の整数チョコレートの笑い声を上げる。さまざまな化学サッカーやアークの笑い声が必要です。ミネアポリスの学部開発者は、チリを手に入れました。パルビナーロットは今座っています。",
                    },
                    {
                        id: "32de17cf-8c35-4ad0-99e2-3328c80c296e",
                        image: {
                            src: "assets/images/miguel-bruna-TzVN0xQhWaQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "妊娠中の弓と温度資産をチャットしないでください。今はソフトにメキシコ人ですが、それは常に局の笑顔です。製造サッカーは笑いを走らせます。またはサラダと温度の場合。そして、マクロサッカーのと。",
                    },
                    {
                        id: "bb64bf13-a35b-4dad-99bf-810f67772471",
                        image: {
                            src: "assets/images/clay-banks-cisdc-344vo-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "プールの賭けはアルコールではありません。いくつかのID径。宿題のフットボールの写真とサッカーのヴィヴェラ靭帯まで。マクロソーススカートまたはエロの必須質量。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-around-the-world",
        name: "世界中で",
        articles: [
            {
                id: "d7923d94-7cd8-418a-865e-2b90faf6f830",
                class: "columns-3-balanced",
                header: "英国",
                image: {
                    src: "assets/images/marc-olivier-jodoin-_eclsGKsUdo-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "しかし、無料の週末は座っていますが、明日のサッカーはDUIです。これは、サラダになることを嫌うように弓を飾ることです。",
                type: "list",
                content: [
                    {
                        id: "a2341f46-19cf-4723-9568-d77b410ba8c4",
                        content: "しかし、痛みですが、それ自体を引っ張る今、バナナはそれを飲みます。ビューローの痛みは、ロレムの非常に痛みが必要です。",
                    },
                    {
                        id: "73423726-07db-4616-8c7d-17f68481245f",
                        content: "しかし、要素のサッカーの抗酸化物質は、利便性が嫌いなサッカーが嫌いです。質量またはfeugiat nisl。",
                    },
                    {
                        id: "f897bb1f-53b8-4e47-a367-d78562e9ee93",
                        content: "それは重要な抗酸化物質であり、大規模な時間の臨床サッカーです。正面にある紫色のサッカーマッサージ。",
                    },
                    {
                        id: "bc5de5a0-d46c-43ce-bdec-5ef55c6cdeb2",
                        content: "テンプレートまたはのターゲティング価格。それは、多くのサラダの漫画マッサージのマクロ価格を確保してください。",
                    },
                ],
            },
            {
                id: "f87a7154-8143-4c09-8afe-96f965e00089",
                class: "columns-3-balanced",
                header: "イタリア",
                image: {
                    src: "assets/images/sandip-roy-4hgTlYb9jzg-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ジャスミンまたは地域のモーリスの範囲を計画するヴィトー。",
                type: "list",
                content: [
                    {
                        id: "ffcb5b5e-a2c1-4066-b807-a62699df06b7",
                        content: "最新のサラダエコロジーサッカー開発者のプロパガンダ。サッカーの醜い法執行機関の価格ジャスミンは大きく震えています。",
                    },
                    {
                        id: "bd5a8aa1-fc84-4882-afdb-efa33d02fc12",
                        content: "必須の航空会社では、スマートな病気やアークの笑顔でカジノが必要です。著者の温度のためのバナナはありません。",
                    },
                    {
                        id: "f5badbd1-d614-44a0-85c9-7f1e6a5f1bcf",
                        content: "このコースのパッチが領域を引く場合。時々、子供たちのベリットのパフォーマンス。",
                    },
                    {
                        id: "420e0800-ef7e-45ee-9bba-d7b44cef4b69",
                        content: "サッカー開発者のサッカーを望んでいます。ナム直径ナム製造ロレムセッド笑い。",
                    },
                ],
            },
            {
                id: "14d07dfb-3587-4411-b4ce-33ba171152f4",
                class: "columns-3-balanced",
                header: "ポーランド",
                image: {
                    src: "assets/images/maksym-harbar-okn8ZIjPMxI-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "しかし、それはそれぞれビューロー妊娠中の化粧で常に笑顔です。",
                type: "list",
                content: [
                    {
                        id: "4611e3bf-0274-408d-a019-c6688e600dd8",
                        content: "サラダにプルバナナが必要です。ニブ地域のテレビは現在、ミサに座っていません。",
                    },
                    {
                        id: "cfe0b6d6-ec48-4571-9bf2-97f26027f80f",
                        content: "直径以外のナム製造ロレムセッドスマイルウルトレシー悲しい。ドゥイの弓を生きたアルコールと悲しみのようにトリガードリンクをトリガーします。",
                    },
                    {
                        id: "a2415445-ab69-445b-9f27-b7b01e432302",
                        content: "それぞれまたはシリアルオルシと。しかし、プロパガンダはARCがさまざまなと言った。",
                    },
                    {
                        id: "08228c09-8678-4e3e-a256-8f528237c9d8",
                        content: "アエネアスですが、学部生は学部生から悲しいまで直径です。矢の週末は抗酸化物質が憎む。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "df191197-ddb0-4c59-978c-560e60e62e0a",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "e9d797f7-36d7-4dbe-8d2a-d6eb8f15bc07",
                        image: {
                            src: "assets/images/ronda-darby-HbMLSB-uhQY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "ストレスですが、パッチのみですが、このコースの領域を引きます。開発者。それにもかかわらず、現在のトリスティックのトラックの大きな推定。首でカートンチョコレートのウォームアップ。テレビとEUですが、選択されました。抗酸化物質ですが、サッカーは利便性を嫌います。",
                        url: "#",
                    },
                    {
                        id: "6b9a85a6-120d-47d6-bc5d-e6d487aedf31",
                        image: {
                            src: "assets/images/dominic-bieri-vXRt4rFr4hI-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "今。笑いのバレージャスミンとマクロは、学部生をプルします。ライフサピエン栄養居住者サッカー悲しい老年。栄養または一部のサラダおよび温度レシピIDの場合。空腹と醜い執行整数。",
                        url: "#",
                    },
                ],
            },
            {
                id: "2ba63655-af94-4da2-a4da-e7464aa070e8",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "9cb71ead-889b-492f-9b47-297ac6d97d96",
                        image: {
                            src: "assets/images/inaki-del-olmo-NIJuEQw0RKg-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "喉にカートンチョコレートのウォームアップであるサッカーの直径。明日、ニブをプルするパフォーマンス。メンバーやメンバーもそうではありません。今すぐチャットしますが、サッカーなどのサッカーメンバーにお願いします。このライオンは醜いミサの生活において、しかし法執行機関の時代の要素です。",
                        url: "#",
                    },
                    {
                        id: "7564b782-691e-494e-9ad1-5de2a2330b17",
                        image: {
                            src: "assets/images/matt-popovich-7mqsZsE6FaU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "サッカーは悲しい老人とネトゥスとマレスアダの飢er。投資家の宿題のウルトレシープールですが、醜い開発者が調査します。サッカーの悲しい老人とネタスの住民。ニンジンを流れるラリート・ニンジン。栄養開発者。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "a97faeaa-1309-44ec-a9a8-dda2db1ad5f3",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "25841bbd-93a3-472b-860f-0b0af2fc8169",
                        image: {
                            src: "assets/images/maksim-larin-tecILYzVAzg-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "質量まで主要な車両での宿題。",
                    },
                ],
            },
            {
                id: "52472e25-5e61-4bef-9aca-ac86f936d811",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "69c42fe8-a06e-4891-ae22-491f04d0a971",
                        image: {
                            src: "assets/images/evie-calder-97CO-A4P0GQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "電子レンジが必要ですが、無料です。電子レンジは無料でレシピが時々変化します。",
                    },
                ],
            },
            {
                id: "a16c0da8-7dea-4cb3-af0e-0c0123bf20d3",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "2342acef-0339-444d-a23c-a33654c91665",
                        image: {
                            src: "assets/images/domino-studio-164_6wVEHfI-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "時々、空腹と最初の味で。モーリスの飲み物のために、チョコレート自体、ライオンの門.",
                    },
                ],
            },
            {
                id: "3e7d37b7-af0e-4f69-a0fd-8d0f64d2e0ba",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "3b57cdb4-8635-4be8-872e-f939538c9e56",
                        image: {
                            src: "assets/images/pat-taylor-12V36G17IbQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "NISLまたは価格は人生のライオンとして選択されました。可能な限り控除可能でない限り、バスケットボールまたはフットボールのジャスミンのパフォーマンス要素はありません。それにもかかわらず、それだけではありません。OKの著者のマクロ。",
                    },
                ],
            },
        ],
    },
];
